<template>
  <div class="discounts">
    <div v-if="callerComp === 'buyNow'" class="smbox" style="margin:0px;">
      <div class="row">
        <div class="col-md-7 col-sm-7 col-7 ">
          <input type="text" class="form-control sm" disabled :value="buyNow_coupon.coupon" v-if="couponApplied">
          <input type="text" id="couponcode" class="form-control sm"
            placeholder="Enter Code Here" v-model="couponcode"
            v-else
          >
        </div>
        <div class="col-md-5 col-sm-5 col-5">
          <div class='d-flex justify-content-center' v-if="isBuynowCouponLoading && isApplyOrRemoveBtnClicked">
           <img :src="staticImgServer + 'assets/spinner-3.gif'" class='coupon-spinner' alt="Loader"/>
          </div>
          <div v-else>
            <button type="button" class="btn btn-outline-info btn-sm form-control text-uppercase"
                    style="height: 30px;" v-if="couponApplied" v-on:click="removeCoupon(true)">Remove</button>
            <button id="couponApply" type="button" class="btn btn-outline-info btn-sm btn-block pointer text-uppercase"
                    style="height: 30px;" v-on:click="applyCoupon(true)" v-else>Apply
            </button>
          </div>
        </div>
      </div>
      <p v-if="!couponApplied && buyNow_couponError" class="error">{{buyNow_couponError}}</p>
      <p v-else-if="!couponApplied && errormsg" class="error">{{errormsg}}</p>
      <p v-if="errorInvalidcoupon" class="error"> Coupon code Invalid OR Not applicable on current cart value. </p>
      <p v-if="couponApplied && buyNowCalculations.coupon_discount" class="savings fsemibold mt5">You Saved ₹ {{parseInt(buyNowCalculations.coupon_discount)}}</p>
      <div v-if="buyNow_validcoupons.length" class="cusTabs accordiontabs">
        <div aria-labelledby="headingOne">
          <div class="row">
            <div class="greybox">
              <div class="pointer" v-for="(coupon, index) in buyNow_validcoupons" @change="selectCoupon(coupon.voucher_code)">
                <div class='d-flex justify-content-between'>
                  <div class='input-radio-text-wrapper'>
                    <label class="radio-container">
                      <input type='radio' :checked="activeCoupon && coupon.voucher_code && activeCoupon.toLowerCase() === coupon.voucher_code.toLowerCase()" id="radio1" name="radio"/>
                      <span class="checkmark"></span>
                    </label>
                    <p class="darkfont mb0">{{coupon.message}}</p>
                  </div>
                  <div v-if="coupon.voucher_code === couponcode && isBuynowCouponLoading && !isApplyOrRemoveBtnClicked">
                    <img :src="staticImgServer + 'assets/spinner-3.gif'" class='coupon-spinner' alt="Loader"/>
                  </div>
                </div>
                <div class="sdivider" v-if="index !== buyNow_validcoupons.length - 1"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else class="smbox" style="margin:0px;">
      <div class="row">
        <div v-if="!$parent.$parent.isDesktop" class="d-flex flex-direction-row col-12 custom-input-parent align-items-center">
          <input type="text" class="custom-input form-control sm" disabled :value="coupon.coupon" v-if="couponApplied">
          <input
            v-else
            type="text" id="couponcode" class="custom-input form-control sm"
            placeholder="Enter Coupon Code" v-model="couponcode"
          />
          <div class='d-flex justify-content-center' v-if="isCouponLoading && isApplyOrRemoveBtnClicked">
           <img :src="staticImgServer + 'assets/spinner-3.gif'" class='coupon-spinner' alt="Loader"/>
          </div>
          <div v-else>
            <span class="custom-input-btn pr-2" v-if="couponApplied" v-on:click="removeCoupon(true)">Remove</span>
            <span class="custom-input-btn pr-2" v-else v-on:click="applyCoupon(true)">APPLY</span>
          </div>
        </div>
        <div v-else class="col-md-7 col-sm-7 col-7 ">
          <input type="text" class="form-control sm" disabled :value="coupon.coupon" v-if="couponApplied">
          <input type="text" id="couponcode" class="form-control sm" placeholder="Enter Code Here"
                 v-model="couponcode" v-else>
        </div>
        <div v-if="$parent.$parent.isDesktop" class="col-md-5  col-sm-5 col-5">
          <div class='d-flex justify-content-center' v-if="isCouponLoading && isApplyOrRemoveBtnClicked">
           <img :src="staticImgServer + 'assets/spinner-3.gif'" class='coupon-spinner' alt="Loader"/>
          </div>
          <div v-else>
            <button type="button" class="btn btn-outline-info btn-sm form-control text-uppercase"
                    style="height: 30px;" v-if="couponApplied" v-on:click="removeCoupon(true)">Remove</button>
            <button id="couponApply" type="button" class="btn btn-outline-info btn-sm btn-block pointer text-uppercase"
                    style="height: 30px;" v-on:click="applyCoupon(true)" v-else>Apply
            </button>
          </div>
        </div>
      </div>
      <p v-if="!couponApplied && couponError" class="error mb0">{{couponError}}</p>
      <p v-else-if="!couponApplied && errormsg" class="error mb0">{{errormsg}}</p>
      <p v-if="errorInvalidcoupon" class="error mb0"> Coupon code Invalid OR Not applicable on current cart value. </p>
      <p v-if="couponApplied && calculations.coupon_discount && $parent.$parent.isDesktop" class="savings fsemibold mt5 mb0">You Saved {{ currencySymbol }} {{parseInt(calculations.coupon_discount)}}</p>
      <!-- <p v-if="couponApplied">Coupon Applied
        <span class="redlink pointer" v-on:click="removeCoupon"><u> Remove </u></span>
      </p> -->
      <div v-if="validcoupons.length" class="cusTabs accordiontabs">
        <div aria-labelledby="headingOne">
          <div class="row">
            <div class="greybox">
              <div class="pointer couponBorder" v-for="(coupon, index) in validcoupons" @click="selectCoupon(coupon.voucher_code)">
                <div class='d-flex justify-content-between'>
                  <div class='input-radio-text-wrapper'>
                    <label class="radio-container">
                      <input type='radio' :checked="activeCoupon && coupon.voucher_code && activeCoupon.toLowerCase() === coupon.voucher_code.toLowerCase()" id="radio1" name="radio"/>
                      <span class="checkmark"></span>
                    </label>
                    <p class="darkfont mb0">{{coupon.message}}</p>
                  </div>
                  <div v-if="coupon.voucher_code === couponcode && isCouponLoading && !isApplyOrRemoveBtnClicked">
                    <img :src="staticImgServer + 'assets/spinner-3.gif'" class='coupon-spinner' alt="Loader"/>
                  </div>
                </div>
                <div class="sdivider" v-if="index !== validcoupons.length - 1"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- <div v-else class='mt20 text-center'>No coupons available</div> -->
    </div>
  </div>
</template>
<script>
  var $ = require('jquery')
  window.jQuery = $
  import {mapGetters, mapState} from 'vuex'
  import {TIMER} from './../../assets/js/stickyPopup.js'
  import Vue from 'vue'

  export default {
    props: ['uptotal', 'upgst', 'discAmt', 'callerComp'],
    data () {
      return {
        couponcode: '',
        responseStatus: false,
        errormsg: '',
        errorInvalidcoupon: false,
        totalAmnt: this.uptotal,
        updGst: this.upgst,
        discmt: this.discAmt,
        cTimer: TIMER,
        isCouponAction: false,
        isApplyOrRemoveBtnClicked: false,
        staticImgServer: process.env.STATIC_IMG_SERVER2
      }
    },
    methods: {
      selectCoupon: function (code, reApplyCoupon) {
        this.isApplyOrRemoveBtnClicked = false
        if (!(code && this.activeCoupon && code.toLowerCase() === this.activeCoupon.toLowerCase()) || reApplyCoupon) {
          this.couponcode = code
          this.applyCoupon(false)
        }
        // if (this.couponApplied && code === this.couponcode) {
        //   this.removeCoupon()
        // } else {
        //   this.couponcode = code
        //   this.applyCoupon()
        // }
      },
      applyCoupon: function (isApplyOrRemoveBtnClicked) {
        this.isApplyOrRemoveBtnClicked = isApplyOrRemoveBtnClicked
        this.isCouponAction = true
        if (this.couponcode === '') {
          this.errorInvalidcoupon = false
          this.responseStatus = false
          this.errormsg = 'Please Enter Coupon Code'
          return false
        } else {
          this.errormsg = ''
          if (this.offerTimer > 0 && this.offerTimer < this.cTimer.OFFER_COUNTDOWN_TIMER) {
            if (this.callerComp === 'buyNow') {
              this.$store.dispatch('VALIDATE_BUYNOW_COUPON', this.couponcode)
            } else {
              this.$store.dispatch('VALIDATE_COUPON', this.couponcode)
            }
          } else {
            if (this.cTimer.COUPON_CODES.includes(this.couponcode)) {
              this.errormsg = 'Invalid coupon code'
              return false
            } else {
              // send coupon without time to get validated over server
              // because we don't know which coupon is applied
              if (this.callerComp === 'buyNow') {
                this.$store.dispatch('VALIDATE_BUYNOW_COUPON', this.couponcode)
              } else {
                this.$store.dispatch('VALIDATE_COUPON', this.couponcode)
              }
            }
          }
        }
      },
      removeCoupon: function (isApplyOrRemoveBtnClicked) {
        this.isApplyOrRemoveBtnClicked = isApplyOrRemoveBtnClicked
        this.isCouponAction = true
        if (this.callerComp === 'buyNow') {
          this.$store.dispatch('REMOVE_BUYNOW_COUPON')
        } else {
          this.$store.dispatch('REMOVE_COUPON')
        }
        // this.couponcode = ''
      }
    },
    beforeDestroy: function () {
      if (this.callerComp === 'buyNow') {
        this.$store.commit('SET_BUYNOW_COUPON_ERROR', '')
      } else {
        this.$store.commit('SET_COUPON_ERROR', '')
      }
    },
    onDestroy: function () {
      this.errormsg = ''
    },
    computed: {
      ...mapGetters([
        'authStatus',
        'coupon',
        'validcoupons',
        'isExclusive',
        'calculations',
        'couponError',
        'buyNow_coupon',
        'buyNow_validcoupons',
        'buyNowCalculations',
        'buyNow_couponError',
        '_cart',
        'isCouponLoading',
        'isBuynowCouponLoading',
        'currencySymbol'
      ]),
      ...mapState({
        offerTimer: 'offerTimer'
      }),
      couponApplied: function () {
        if (this.callerComp === 'buyNow') {
          return !!this.buyNow_coupon.coupon
        } else {
          return !!this.coupon.coupon
        }
      },
      activeCoupon: function () {
        if (this.callerComp === 'buyNow') {
          return this.buyNow_coupon && this.buyNow_coupon.coupon ? this.buyNow_coupon.coupon : ''
        } else {
          return this.coupon && this.coupon.coupon ? this.coupon.coupon : ''
        }
      }
    },
    mounted () {
      if (this.callerComp === 'buyNow') {
        if (this.isCouponAction) {
          this.isCouponAction = false
        } else {
          this.$store.dispatch('BUYNOW_VALID_COUPONS')
        }
      }
    },
    watch: {
      couponcode (value) {
        if (this.callerComp === 'buyNow') {
          if (value === '' && this.buyNow_couponError) {
            this.$store.commit('SET_BUYNOW_COUPON_ERROR', '')
          }
        } else {
          if (value === '' && this.couponError) {
            this.$store.commit('SET_COUPON_ERROR', '')
          }
        }
      },
      coupon (value) {
        if (!(value && value.coupon)) {
          this.couponcode = ''
        }
      },
      buyNow_coupon () {
        if (!(this.buyNow_coupon && this.buyNow_coupon.coupon)) {
          this.couponcode = ''
        }
      },
      _cart () {
        if (this.isCouponAction) {
          this.isCouponAction = false
        } else {
          this.$store.dispatch('VALID_COUPONS')
        }
      },
      couponApplied () {
        if (!this.$parent.$parent.isDesktop) {
          Vue.toasted.show(
            this.couponApplied ? 'Coupon applied successfully.' : 'Coupon removed successfully.',
            {
              theme: 'primary',
              className: 'toasted-mobileDefault',
              position: 'bottom-right',
              duration: 2000
            }
          )
        }
      }
    }
  }
</script>
<style scoped>
.coupon-spinner{
  width: 25px;
}
.input-radio-text-wrapper p {
  margin-top: 2px;
}
.input-radio-text-wrapper {
  display: flex;
  gap: 1.5rem;
  min-height: 25px;
}
/* The container */
.radio-container {
  display: block;
  position: relative;
  margin-top: .3rem;
  cursor: pointer;
  font-size: 22px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

/* Hide the browser's default radio button */
.radio-container input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
}

/* Create a custom radio button */
.checkmark {
  position: absolute;
  top: 0;
  left: 0;
  height: 16px;
  width: 16px;
  border: 1px solid #a7a9ac;
  border-radius: 50%;
}
.couponBorder {
  padding-top: 5px;
}


/* When the radio button is checked, add a blue background */
.radio-container input:checked ~ .checkmark {
  border: 1px solid #148c8d;
}

/* Create the indicator (the dot/circle - hidden when not checked) */
.checkmark:after {
  content: "";
  position: absolute;
}

/* Show the indicator (dot/circle) when checked */
.radio-container input:checked ~ .checkmark:after {
  display: block;
  background-color: #148c8d;
  top: 3px;
  left: 3px;
  width: 8px;
  height: 8px;
	border-radius: 50%;
}

  .discounts .cusTabs {
    margin-top: 10px;
  }
  .discounts .btn {
    border-radius: 5px;
  }
  .discounts-title {
    font-size: 15px;
    color: #117a7a;
    margin-left: 10px;
    margin-bottom: 10px;
  }
  .savings {
    color: green;
  }
  .discounts .smbox {
    background: none;
    padding: 0 10px;
  }
  .discounts .card-header {
    padding: 0;
    min-height: 0;
  }
  .discounts .greybox {
    background: none;
    margin: 0;
    padding: 0px 12px;
    width: 100%;
  }
  .discounts .greybox .sdivider {
    margin: 13px 0px;
    margin-left: -10px;
    margin-right: -10px;
  }
  .discount-accordion {
    font-size: 10px;
    color: #117a7a;
  }
  .discounts .card-header h5 {
    margin: 0;
  }
  .discounts .accordiontabs h5 a {
    font-family: 'Source Sans Pro', sans-serif;
font-weight: 400;
  }

  .discounts .voucher-code {
    color: #117a7a;
  }

  .discounts .voucher-code:hover {
    text-decoration: underline;
  }
  .cusTabs a:before {
    font-family: 'Glyphicons Halflings';
    content: "\25be";
    float: right;
    transition: all 0.5s;
  }
  .tncWrapper {
    margin-top: 10px;
    text-align: left;
    line-height: 5px;
  }
  .offTnc {
    color: #117a7a;
    font-size: 14px;
  }
  .offTnc:hover, .offTnc:visited, .offTnc:focus {
    color: #117a7a;
  }
  @media only screen and (max-width: 480px) {
    .discounts .greybox {
      padding: 0px 6px;
    }
    .custom-input-parent {
      border: 1px solid rgba(0,0,0,.15);
      border-radius: 3px;
    }
    .custom-input {
      line-height: 30px !important;
      flex-grow:2;
      /* And hide the input's outline, so the form looks like the outline */
      border:none;
    }
    .custom-input:disabled {
      background-color: transparent;
      color: green;
      font-weight: bold;
    }
    .custom-input:focus {
      /* removing the input focus blue box. Put this on the form if you like. */
      outline: none;
    }
    .custom-input::placeholder {
      font-weight: 600;
      -webkit-text-stroke: 0.35px #FFF;
      -webkit-font-smoothing: antialiased;
    }
    .custom-input-btn {
      color: #117a7a;
      font-weight: bold;
    }
  }
</style>



// WEBPACK FOOTER //
// discountCode.vue?401d34af